import { observable, action } from 'mobx'
import { StoreExt } from 'util/reactExt'

export class UserStore extends StoreExt {
  @observable
  userInfo: {
    staff_name: string
    img_url: string
    unanswer: number
    learn_time: number
    manage_type: number
  } = {
    staff_name: '',
    img_url: '',
    unanswer: 0,
    learn_time: 0,
    manage_type: 0,
  }

  @observable
  userLevel: {
    business_level: string
    professional_level: string
  } = {
    business_level: '',
    professional_level: '',
  }

  @action
  initUserInfo = async () => {
    try {
      const data = await this.api.user.getUserInfo()
      this.setUserInfo(data)
    } catch (e) {
      console.error(e)
      throw new Error(e)
    }
  }

  @action
  fetchUserLevel = async () => {
    const userLevel = await this.api.user.getUserLevel()
    this.setUserLevel(userLevel)
  }

  @action
  setUserInfo = data => {
    this.userInfo = data
    localStorage.setItem('USER_INFO', data)
  }

  @action
  setUserLevel = data => {
    this.userLevel = data
  }
}

export default new UserStore()
